module.exports = {
	"header": "Bonnierförlagen - A Sales Growth Success Story",
	"date": "2023/06/19",
	"imgSrc": "Bonnierforlagen_case_study.png",
	"imgAlt": "Bonnierförlagen - A Sales Growth Success Story",
	"ingress": "Spotin’s content commerce solution shows positive results for Sweden’s largest book publisher Bonnierförlagen, with a 70X YoY and 59% MoM sales growth on Spotin enabled check-outs.",
	"sections": [
		{
			"paragraphs": [
				"<strong>Download PDF: <a href='https://storage.googleapis.com/spotin/doc/news/15/Spotin-Bonnerforlagen-a_sales_growth_success_story.pdf' download style='text-decoration: underline;'>English</a></strong>"
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./pages/news/15/article.json
// module id = 13
// module chunks = 0